'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var earth7 = exports.earth7 = '#3B261F';
var earth6 = exports.earth6 = '#4E2F24';
var earth5 = exports.earth5 = '#613728';
var earth4 = exports.earth4 = '#74402D';
var earth3 = exports.earth3 = '#8B4E30';
var earth2 = exports.earth2 = '#A15D32';
var earth1 = exports.earth1 = '#B86B36';
var earth = {
  7: earth7,
  6: earth6,
  5: earth5,
  4: earth4,
  3: earth3,
  2: earth2,
  1: earth1
};
exports.default = earth;